import { t } from 'i18next';

export enum KeySource {
  AWS_KMS = 'AWS_KMS',
  AZURE_KEY_VAULT = 'AZURE_KEY_VAULT',
  DERIVED = 'DERIVED',
  EXCHANGED = 'EXCHANGED',
  KEYSTORE = 'KEYSTORE',
  CREATED = 'CREATED',
  GENERATED = 'GENERATED',
  UNKNOWN = 'UNKNOWN',
}

export const getKeySourceLabel = (source: KeySource): string => {
  return t(`keyProperties.sources.${source}`);
};
